import { MemoizedSelector, createFeatureSelector } from '@ngrx/store';

import { UserFeatureState } from '../states';

export const selectUserFeatureState: MemoizedSelector<object, UserFeatureState> = createFeatureSelector<UserFeatureState>('userFeature');
